"use client";
import { jsx } from "react/jsx-runtime";
import { component } from "@gnist/component-utils";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { progressBarStyles, progressBar, progressAnimation, progressPercentage } from "./ProgressBar.css.js";
import { tokens } from "@gnist/themes/tokens.css.js";
const ProgressBarComponent = ({ color = tokens.color.primary, percentage, animateOnChange = false, size = "medium", ...delegated }) => {
  if (percentage < 0 || percentage > 100) {
    throw new Error("The value of the progress bar must be a number between 0 and 100.");
  }
  const barHeight = size === "small" ? tokens.size.xxs : size === "medium" ? tokens.size.xs : "var(--moller-size-s)";
  return jsx("div", { className: progressBarStyles, style: {
    minHeight: `calc(${barHeight} / 2)`
  }, ...delegated, children: jsx("div", { className: `${progressBar} ${animateOnChange ? "" : progressAnimation}`, style: {
    ...assignInlineVars({
      [progressPercentage]: `${percentage}%`
    }),
    backgroundColor: color,
    width: `${percentage}%`
  } }) });
};
const ProgressBar = component("Progress Bar", progressBarStyles, ProgressBarComponent);
export {
  ProgressBar,
  ProgressBarComponent
};
